import { InjectionKey } from "vue";

export default Symbol() as InjectionKey<(props: string[]) => void | null>;
